import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const LaptopMag: Site = {
  id: 'laptopmag',
  logo: 'svg/laptopmag.svg',
  label: 'Laptop Mag',
  analyticsName: 'laptopmag',
  hostname: 'laptopmag.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
